module.exports = __webpack_public_path__ + "assets/analytics.f1f9a1a6.svg";